import { BaseAPI } from "@/api/baseAPI";
import apiClient from "@/api/apiClient";
import { extractApiData } from "@/utils/apiResponseHandler";
import type { Context, ContextType } from "@/types";

class ContextAPI extends BaseAPI<Context> {
  constructor() {
    super("context");
  }

  /**
   * Fetch all context types.
   * @returns Promise resolving to an array of context types.
   */
  async fetchContextTypes(): Promise<ContextType[]> {
    return await apiClient
      .get(`${this.model}/types`)
      .then(extractApiData);
  }
}

export default new ContextAPI();
